// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from ProductInfo.module.scss  */
.ProductInfo-module-Root_1K2 {
  font-size: 14px;
  line-height: 21px;
  color: #576875; }

.ProductInfo-module-Label_1bw {
  margin-right: 4px; }

.ProductInfo-module-Link_Sgo {
  color: inherit; }
  .ProductInfo-module-Link_Sgo:hover {
    color: #8168f0; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Product/Info/ProductInfo.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc,EAAE;;AAElB;EACE,iBAAiB,EAAE;;AAErB;EACE,cAAc,EAAE;EAChB;IACE,cAAc,EAAE","sourcesContent":["/*  imported from ProductInfo.module.scss  */\n.ProductInfo-module-Root_1K2 {\n  font-size: 14px;\n  line-height: 21px;\n  color: #576875; }\n\n.ProductInfo-module-Label_1bw {\n  margin-right: 4px; }\n\n.ProductInfo-module-Link_Sgo {\n  color: inherit; }\n  .ProductInfo-module-Link_Sgo:hover {\n    color: #8168f0; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
